import { useCallback, useEffect, useState } from "react";

import { useComposerIsLoading } from "Flocknote/stateHooks";

import {
  useActiveAction,
  useSendEmailActiveAction,
} from "Dashboard/components/WhatsNext/whatsNextStore";
import { useSendEmailRef } from "NavBar/navBarStore";

import FnrContainedIcon from "UI/FnrContainedIcon";
import { navColors } from "UI/colors";

import useIsHoverFocused from "Utilities/Hooks/useIsHoverFocused";

import Button from "./components/Button";
import { hoverTextKeys, useHoverTextKey } from "./toolbarStore";

const SendEmail = () => {
  const [wasClicked, setWasClicked] = useState(false);
  const [composerIsLoading, setComposerIsLoading] = useComposerIsLoading();
  const [, setActiveAction] = useActiveAction();
  const sendEmailActiveAction = useSendEmailActiveAction();
  const sendEmailRef = useSendEmailRef();

  const [, setHoverTextKey] = useHoverTextKey();
  const isHoverFocused = useIsHoverFocused(sendEmailRef);

  useEffect(() => {
    if (isHoverFocused) setHoverTextKey(hoverTextKeys.email);
    else setHoverTextKey(hoverTextKeys.noHover);
  }, [isHoverFocused, setHoverTextKey]);

  useEffect(() => {
    if (!composerIsLoading) setWasClicked(false);
  }, [composerIsLoading]);

  const handleClick = useCallback(() => {
    setComposerIsLoading(true);
    setWasClicked(true);
    if (sendEmailActiveAction) setActiveAction(undefined);
  }, [sendEmailActiveAction, setActiveAction, setComposerIsLoading]);

  return (
    <div
      className="main_button compose_button compose_button_email"
      data-type="email"
      data-cy="emailComposeButton"
      data-flashing={sendEmailActiveAction || undefined}
      style={{ all: "unset" }}
    >
      <Button
        color={navColors.groups}
        onClick={handleClick}
        ref={sendEmailRef}
        isFlashing={sendEmailActiveAction}
      >
        <FnrContainedIcon
          icon="envelope far"
          color="textLight"
          shadow
          isLoading={wasClicked && composerIsLoading}
        />
      </Button>
    </div>
  );
};
export default SendEmail;
